import type { FC } from "react";
import type { IconProps } from "@stubhub/broadway-web/icons";
import { PriceTrend } from "src/http/types";

/** X-coordinate for the downward arrow indicator above each bar: Low=green(6), Typical=yellow(17), High=red(28) */
const ARROW_X = {
  [PriceTrend.Low]: 6,
  [PriceTrend.Typical]: 17,
  [PriceTrend.High]: 28,
} as const;

/**
 * Custom icon showing a 3-bar price meter (green/yellow/red) with a
 * downward arrow above the bar matching the current price trend.
 */
export const createPriceMeterIcon = (priceTrend: PriceTrend): FC<IconProps> => {
  const arrowX = ARROW_X[priceTrend];
  const PriceMeterIcon: FC<IconProps> = (props) => (
    <svg viewBox="0 0 34 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="34" height="20" {...props}>
      {/* Arrow indicator */}
      <path d={`M${String(arrowX - 3)} 3l3 5l3-5z`} fill="#1B1B1B" />
      {/* Green - rounded left, flat right */}
      <path d="M2 10h9v6H2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2z" fill="#1A8917" />
      {/* Yellow - flat both sides */}
      <rect x="12" y="10" width="10" height="6" fill="#E8A317" />
      {/* Red - flat left, rounded right */}
      <path d="M23 10h9a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-9v-6z" fill="#D32F2F" />
    </svg>
  );
  return PriceMeterIcon;
};
